import { createContext, useContext, useCallback, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS, DEFAULT_LANG, LANGUAGES } from "./translations";

const STORAGE_KEY = "aura-lang";

const LanguageContext = createContext({
  lang: DEFAULT_LANG,
  setLang: () => {},
  languages: LANGUAGES,
  t: (key) => key,
});

/**
 * Dil sağlayıcı. Seçilen dili localStorage'da tutar ve t(key[, vars]) ile
 * çeviri döndürür. Anahtar seçili dilde yoksa tr'ye, o da yoksa anahtarın
 * kendisine düşülür (böylece eksik çeviride ekran boş kalmaz).
 */
export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored && TRANSLATIONS[stored] ? stored : DEFAULT_LANG;
  });

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const setLang = useCallback((id) => {
    if (!TRANSLATIONS[id]) return;
    localStorage.setItem(STORAGE_KEY, id);
    setLangState(id);
    document.documentElement.setAttribute("lang", id);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = TRANSLATIONS[lang] || TRANSLATIONS[DEFAULT_LANG];
      let str = dict[key] ?? TRANSLATIONS[DEFAULT_LANG][key] ?? key;
      if (vars) {
        for (const [k, v] of Object.entries(vars)) {
          str = str.replace(new RegExp(`\\{${k}\\}`, "g"), v);
        }
      }
      return str;
    },
    [lang]
  );

  const value = useMemo(
    () => ({ lang, setLang, languages: LANGUAGES, t }),
    [lang, setLang, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  return useContext(LanguageContext);
}
